class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.anchor = this.querySelector('a');
    if (!this.anchor) return;

    // Start loading well before the user reaches the end
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
      },
      { rootMargin: '0px 0px 1500px 0px' }
    );

    this.observer.observe(this);
  }

  async loadNextPage() {
    this.observer.disconnect();

    const base = this.anchor.getAttribute('href');
    if (!base) return;
    // the clean ?page=N link stays in the HTML for Google; the section id is added only here
    const url = base + (base.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + this.anchor.dataset.section;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newGrid = html.querySelector('[data-product-grid]');
      const grid = document.querySelector('[data-product-grid]');

      if (newGrid && grid) {
        const fragment = document.createDocumentFragment();
        Array.from(newGrid.children).forEach((child) => {
          // show instantly: strip scroll-reveal animation classes
          child.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
          child.removeAttribute('data-cascade');
          child.style.animation = 'none';
          child.style.opacity = '1';
          child.style.transform = 'none';
          fragment.appendChild(child);
        });
        grid.appendChild(fragment); // one DOM update instead of many
      }

      const newInfinite = html.querySelector('infinite-scroll');
      if (newInfinite) {
        this.replaceWith(newInfinite);
      } else {
        this.remove();
      }
    } catch (err) {
      console.error('InfiniteScroll error:', err);
      setTimeout(() => { if (this.isConnected) this.observer.observe(this); }, 3000);
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);